import React from 'react';
import classNames from 'classnames';

import PrimaryButton from './buttons/PrimaryButton';
import { formatCurrency } from '../../lib/utils/formatters';

export default function PayNowCard({
  term,
  selectedTerm,
  setSelectedTerm,
  onContinue,
  cart,
  isLoading,
  showRateBadge = true,
}) {
  const amount =
    parseFloat(term.get('total_amount')) || parseFloat(cart?.grand_total);
  const fees = parseFloat(term.get('total_fees'));
  const grandTotal = parseFloat(cart?.grand_total);
  const feePercent = grandTotal > 0 ? (fees / grandTotal) * 100 : 0;
  const isSelected = selectedTerm?.term_period === 'now';

  const handleSelect = () => {
    if (!isSelected) {
      setSelectedTerm({ term: 0, term_period: 'now', payment: amount });
    }
  };

  const handleKeyDown = (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleSelect();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-pressed={isSelected}
      className={classNames(
        'mb-4 border rounded-2xl p-5 bg-white shadow-sm transition-all',
        isSelected
          ? 'border-[3px] border-primary-blue'
          : 'border-zinc-300 hover:border-blue-300 cursor-pointer'
      )}
      onClick={handleSelect}
      onKeyDown={handleKeyDown}
    >
      <div className="flex items-start justify-between mb-1">
        <div>
          <h2 className="text-base sm:text-lg font-bold">Pay Now</h2>
          <p className="text-xs sm:text-sm text-secondary-gray mt-0.5">
            Pay in full today with your bank account.
          </p>
        </div>
        {showRateBadge && (
          <span
            className={classNames(
              'text-xs font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap ml-3',
              fees === 0
                ? 'bg-background-success text-success border-green-200'
                : 'bg-blue-50 text-primary-blue border-blue-200'
            )}
          >
            {fees === 0 ? 'No fee' : `${feePercent.toFixed(2)}% fee`}
          </span>
        )}
      </div>
      {isSelected && (
        <div className="mt-4">
          <dl className="text-sm pt-3 mt-3 border-t border-primary-border-gray">
            <div className="flex items-center justify-between mb-2">
              <dt>Order total</dt>
              <dd>{formatCurrency(grandTotal)}</dd>
            </div>
            <div className="flex items-center justify-between mb-2">
              <dt>Term fee</dt>
              <dd>{formatCurrency(fees)}</dd>
            </div>
            <div className="flex items-center justify-between mb-2 font-semibold">
              <dt>1 payment today:</dt>
              <dd>{formatCurrency(amount)}</dd>
            </div>
          </dl>
          <PrimaryButton
            buttonText="Continue"
            buttonColor="bg-primary-blue"
            hoverClass="hover:bg-primary-blue-hover"
            disabled={isLoading}
            isLoading={isLoading}
            onClick={onContinue}
          />
        </div>
      )}
    </div>
  );
}
